import React, {useState} from "react"
import {AiOutlineCloseCircle} from "react-icons/ai";
import {Button, FormItem, Input} from "@vkontakte/vkui";

const AddShop = ({callback,closePop}) =>{
    const [name,setName] = useState("")
    const [adres,setAdres] = useState("")
    const [phone,setPhone] = useState("")
    const [time,setTime] = useState("")
    return (
        <div className={"content add_type_content"}>
            <div style={{ width: "95%", display: "flex",alignContent:"center", justifyContent: "flex-end"}}>
                <span className={"font_montserrat w_700"} style={{fontSize:25,justifySelf:"center"}}>Создание магазина</span>
                <button onClick={closePop} style={{position:"relative",alignSelf:"flex-end",justifySelf:"flex-end"}}
                        className={"close_cropik"}><AiOutlineCloseCircle color={"red"}
                                                                         size={30}/></button>
            </div>
            <div className={"create_content"}>
                <FormItem style={{width:"100%"}} top={"Наименование точки"}>
                    <Input value={name} onChange={(e)=>setName(e.currentTarget.value)}/>
                </FormItem>
                <FormItem style={{width:"100%"}} top={"Адрес"}>
                    <Input value={adres} onChange={(e)=>setAdres(e.currentTarget.value)}/>
                </FormItem>
                <FormItem style={{width:"100%"}} top={"Телефон"}>
                    <Input value={phone} onChange={(e)=>setPhone(e.currentTarget.value)}/>
                </FormItem>
                <FormItem style={{width:"100%"}} top={"График"}>
                    <Input value={time} onChange={(e)=>setTime(e.currentTarget.value)}/>
                </FormItem>
                <Button size={"l"} stretched mode={"commerce"} onClick={()=>callback(name,adres,phone,time)}>Добавить</Button>
            </div>
        </div>
    )
}
export default AddShop